import { render } from "./SectionAboutUs.vue?vue&type=template&id=b00b10ec&scoped=true"
import script from "./SectionAboutUs.vue?vue&type=script&lang=js"
export * from "./SectionAboutUs.vue?vue&type=script&lang=js"

import "./SectionAboutUs.vue?vue&type=style&index=0&id=b00b10ec&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00b10ec"]])

export default __exports__